/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc
 */

export const createApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'createApproval',
  auth: 'app',
  fingerprint: 'nfcmQFdJZlBGueHMg0kDIIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createBulkApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'createBulkApproval',
  auth: 'app',
  fingerprint: '20hyZGIM9bol45794fhtNIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getLatestApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'getLatestApproval',
  auth: 'app',
  fingerprint: 'oVgYyyFd-qz3xtI7Woib6IT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'getApproval',
  auth: 'app',
  fingerprint: 'tO7k9L9wKAEP3NgL5qsPqYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const approveApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'approveApproval',
  auth: 'app',
  fingerprint: 'w3LXpRbTttOsTttPjyYN4IT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const approveApprovalStepRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'approveApprovalStep',
  auth: 'app',
  fingerprint: '-GF6GyjPgYIAXNCDN65lMIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const rejectApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'rejectApproval',
  auth: 'app',
  fingerprint: 'TCiJepipaVO7iB3U_UOmkIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const rejectApprovalStepRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'rejectApprovalStep',
  auth: 'app',
  fingerprint: '5BOwN5YSTXS5N_7InIIGoYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const requestChangesOnApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'requestChangesOnApproval',
  auth: 'app',
  fingerprint: 'oyjmK_MVwfoeaTDA6RbcXoT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const requestChangesOnApprovalStepRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'requestChangesOnApprovalStep',
  auth: 'app',
  fingerprint: 'wgj03fpBv8YkDHCAh1Ibk4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const markChangesResolvedRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'markChangesResolved',
  auth: 'app',
  fingerprint: 'PSHl0Mk40-nzRkN76YFyW4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const requestAgentToApplyChangesRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'requestAgentToApplyChanges',
  auth: 'app',
  fingerprint: 'SZamX2qNXua9kx2Jj3hbCYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const requestAgentToReviewRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'requestAgentToReview',
  auth: 'app',
  fingerprint: 'gupRi2mXeYpoV53V6gXhSoT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cancelAgentTurnRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'cancelAgentTurn',
  auth: 'app',
  fingerprint: 'HKdvkEMvTjJEYRYcVjocnYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cancelApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'cancelApproval',
  auth: 'app',
  fingerprint: 'HrDzSXNmqRtVV_F-651SnYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const concludeApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'concludeApproval',
  auth: 'app',
  fingerprint: 'tO-XK7M_hRVIRwLD1j28LIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'updateApproval',
  auth: 'app',
  fingerprint: 'I3aHlCZVQ6siwWoXGVX32YT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendReminderNotificationRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'sendReminderNotification',
  auth: 'app',
  fingerprint: 'CLm0NFVWppmLVdc5zf35iYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};